module.exports = __webpack_public_path__ + "static/media/allergysymptoms-2_m@2x.6426836b.jpg";